<template>
<v-dialog
    v-model="dialog"
    max-width="920"
>
    <v-card>
        <v-card-title>Send Mode</v-card-title>

        <v-card-text>

            <v-select
                label="Send Mode"
                :items="$rc.enumChoices('auto_message_send_mode',false)"
                v-model="value_current"
                hide-details
            />

            <div v-if="show_auto_attestations" class="attestation-container">

                <v-checkbox
                    label="I have tested my message and am happy with the message and any attachments"
                    v-model="test_acknowledgement"
                />

                <m-legal-agreement
                    type="auto-message-attestation"
                    :organization_id="current_organization_id"
                    v-model="consent_acknowledgement"
                    ref="bulk_message_attestation"
                />

                <div v-if="is_double_opt_in_message" class="double-opt-in-section">

                    <v-alert
                        type="warning"
                        border="left"
                        outlined
                        dense
                        class="mt-6 mb-2"
                    >
                        <strong>Warning:</strong> This is a double opt-in message, please read the below implications before proceeding.
                    </v-alert>

                    <m-legal-agreement
                        type="auto-message-double-opt-in-attestation"
                        :organization_id="current_organization_id"
                        v-model="double_opt_in_consent_acknowledgement"
                        ref="double_opt_in_attestation"
                    />
                </div>
            </div>

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
                Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onChangeMode"
                :disabled="!can_change_mode"
            >
                Change Mode
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    props: {
        organization_id: {
            type: String,
            default: null,
        },

        template_context: {
            type: String,
            default: null,
        },

        template_subject_id: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            dialog: false,

            value_original: null,
            value_current: null,

            consent_acknowledgement: false,
            double_opt_in_consent_acknowledgement: false,
            test_acknowledgement: false,

        }
    },

    methods: {

        showDialog(value)
        {
            this.dialog = true;

            this.value_original = _.cloneDeep(value);
            this.value_current = _.cloneDeep(value);

            this.consent_acknowledgement = false;
            this.double_opt_in_consent_acknowledgement = false;
            this.test_acknowledgement = false;
        },

        onChangeMode()
        {
            if ( this.value_current != 'auto' )
            {
                this.doChange();
                return;
            }

            if ( !this.consent_acknowledgement || !this.test_acknowledgement )
            {
                alert('You must accept all checkbox agreements');
                return;
            }

            if ( this.is_double_opt_in_message && !this.double_opt_in_consent_acknowledgement )
            {
                alert('You must accept the double opt-in attestation agreement');
                return;
            }

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/legal/sign-auto-message-attestation',

                'params' : {
                    'organization_id': this.current_organization_id,
                    'template_context': this.current_template_context,
                    'template_subject_id': this.current_template_subject_id,
                    },

                'on_success': (data) => {
                        if ( this.is_double_opt_in_message )
                        {
                            this.signDoubleOptInAttestation();
                        }
                        else
                        {
                            this.doChange();
                        }
                    },

                'on_error': 'Unable to sign automated message attestation',
            });
        },

        signDoubleOptInAttestation()
        {
            const attestation_component = this.$refs.double_opt_in_attestation;
            if (!attestation_component) {
                alert('Error: Could not find attestation.');
                return;
            }

            const written_text = attestation_component.getSpecimen() || '';
            const agreement_specimen = attestation_component.data?.plain_text_specimen || '';
            
            const combined_specimen = `[${written_text}] ${agreement_specimen}`;

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/legal/sign-auto-message-double-opt-in-attestation',

                'params' : {
                    'organization_id': this.current_organization_id,
                    'template_context': this.current_template_context,
                    'template_subject_id': this.current_template_subject_id,
                    'specimen': combined_specimen,
                    },

                'on_success': (data) => {
                        this.doChange();
                    },

                'on_error': 'Unable to sign double opt-in attestation',
            });
        },

        doChange()
        {
            this.dialog = false;
            this.$emit('change', this.value_current);
        },

        onCancel()
        {
            this.dialog = false;
        },

    },

    computed: {
        current_organization_id() {
            return this.organization_id || this.$route.params.organization_id;
        },

        current_template_context() {
            return this.template_context || this.$route.params.template_context;
        },

        current_template_subject_id() {
            return this.template_subject_id || this.$route.params.template_subject_id;
        },

        show_auto_attestations() {
            return this.value_current == 'auto' && this.value_original != this.value_current;
        },

        can_change_mode() {
            if ( this.value_current == this.value_original )
                return false;

            if ( this.show_auto_attestations )
            {
                if ( this.consent_acknowledgement == false )
                    return false;

                if ( this.test_acknowledgement == false )
                    return false;

                if ( this.is_double_opt_in_message && this.double_opt_in_consent_acknowledgement == false )
                    return false;
            }

            return true;
        },

        is_double_opt_in_message() {
            return this.current_template_context === 'order-placed-request-opt-in';
        }
    },
}
</script>

<style lang="scss" scoped>

</style>
